export default __webpack_public_path__ + "static/media/reddit-1.55d1215e.webp";